<script>
import broker from "../../utils/broker";
export default {
  props: ["data", "addClass"],
  data() {
    return {
      slider: [],
      swiperOption: {
        speed: 1500,
        loop: true,
        effect: "fade",
        autoplay: false,
        spaceBetween: 30,
        navigation: {
          nextEl: ".ht-swiper-button-next",
          prevEl: ".ht-swiper-button-prev",
        },
      },
    };
  },
  mounted() {
    broker.fetch
      .get(`/webschool/content?types[]=banner&status=published`)
      .then((res) => {
        const data = res.data.data;
        const singleData = data.find((o) => o.type.name === "banner");
        if (data.length === 1) {
          this.slider = data.concat(singleData).concat(singleData);
        } else {
          this.slider = data;
        }
      });
  },
};
</script>

<style lang="scss">
.black-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
}
</style>
<template>
  <div class="hero-alider-area">
    <div class="hero-slider__container-area">
      <div class="swiper-container hero-slider__container">
        <div class="swiper-wrapper hero-slider__wrapper">
          <swiper :options="swiperOption">
            <!--=======  single slider item  =======-->
            <div
              class="swiper-slide hero-slider__single-item"
              :style="{ backgroundImage: `url(${item.image})` }"
              v-for="(item, index) in slider"
              :key="index"
            >
              <div class="black-overlay"></div>
              <div class="hero-slider__content-wrapper">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12">
                      <div
                        class="hero-slider__content"
                        :class="[
                          addClass ? 'hero-slider__content--center' : '',
                        ]"
                      >
                        <h2 class="hero-slider__title">{{ item.title }}</h2>
                        <p class="hero-slider__text">{{ item.body }}</p>
                        <!-- <router-link to="/contact" class="hero-slider__btn">Lihat Profil</router-link> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--=======  End of single slider item  =======-->
            <div
              class="ht-swiper-button-prev ht-swiper-button-prev-13 ht-swiper-button-nav d-none d-xl-block"
            >
              <i class="ion-ios-arrow-left"></i>
            </div>
            <div
              class="ht-swiper-button-next ht-swiper-button-next-13 ht-swiper-button-nav d-none d-xl-block"
            >
              <i class="ion-ios-arrow-forward"></i>
            </div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>
